import { render, staticRenderFns } from "./PackageDescription.vue?vue&type=template&id=760320f0&scoped=true"
import script from "./PackageDescription.vue?vue&type=script&lang=js"
export * from "./PackageDescription.vue?vue&type=script&lang=js"
import style0 from "./PackageDescription.vue?vue&type=style&index=0&id=760320f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760320f0",
  null
  
)

export default component.exports